<template>
  <section id="js-scroll" class="cooperation">
    <div v-if="isComplete">
      <h2 class="sub-title">
        {{ Cooperation.title[lang] }}
      </h2>
      <p class="oauth-description">
        {{ eventLinkDescriptionText }}
      </p>
      <p class="oauth-sentence app-name">
        {{ Cooperation.appRegisterName[lang] }}&nbsp;{{ runnerName }}
      </p>
      <p class="oauth-description">
        {{ Cooperation.appRegisterSentence[lang] }}
      </p>
      <p class="oauth-sentence">
        <img src="../../../assets/images/triangle-right-purple.svg" alt="" />
        <span class="link">
          {{ Cooperation.appRegisterSentence2[lang]
          }}<a
            :href="`${Cooperation.pdf[lang]}`"
            class="t-underline"
            target="_blank"
            rel="noopener"
            >{{ Cooperation.here[lang] }}</a
          >
        </span>
      </p>
      <div class="app-os">iOS</div>
      <div class="app-image">
        <p class="app-image__p">{{ Cooperation.runkeeperMap[lang] }}</p>
        <img
          :src="`https://tmf-virtualrun.jp/images/oauth/${lang}/runkeeper-ios-app-map.png`"
          width="270"
          alt=""
          class="img"
        />
        <p class="app-image__p">{{ Cooperation.runkeeperMenu[lang] }}</p>
        <img
          :src="`https://tmf-virtualrun.jp/images/oauth/${lang}/runkeeper-ios-app-menu.png`"
          width="270"
          alt=""
          class="img"
        />
      </div>
      <div class="app-os">Android</div>
      <div class="app-image">
        <p class="app-image__p">{{ Cooperation.runkeeperMapAndroid[lang] }}</p>
        <img
          :src="`https://tmf-virtualrun.jp/images/oauth/${lang}/runkeeper-android-app-map.png`"
          width="270"
          alt=""
          class="img"
        />
        <p class="app-image__p">{{ Cooperation.runkeeperMenu[lang] }}</p>
        <img
          :src="`https://tmf-virtualrun.jp/images/oauth/${lang}/runkeeper-android-app-menu.png`"
          width="270"
          alt=""
          class="img"
        />
      </div>
      <div class="event-detail">
        <img src="../../../assets/images/triangle-right-purple.svg" alt="" />
        <router-link
          :to="{
            path: `/${langPath}${
              $route.path.includes('company') ? 'company/' : ''
            }event/${nassId}`,
          }"
          class="link t-underline"
        >
          {{ eventDetailText }}
        </router-link>
      </div>
      <dl class="cooperation__dl">
        <dt class="cooperation__dl--dt">
          {{ Cooperation.cancel[lang] }}
        </dt>
        <dd class="cooperation__dl--dd">
          {{ Cooperation.cancelSentence[lang] }}
        </dd>
        <dd class="cooperation__dl--dd">
          <PrimaryButton type="button" @click.native="releaseEvent">
            {{ Cooperation.release[lang] }}
          </PrimaryButton>
        </dd>
      </dl>
    </div>
    <!-- 解除完了 -->
    <Release v-if="isRelease" :lang="lang"></Release>
  </section>
</template>

<script>
import Cooperation from "../../../assets/constants/confirmation/cooperation/cooperation";
import Release from "./Release";
import PrimaryButton from "./PrimaryButton";
import { RepositoryFactory } from "../../../api/RepositoryFactory";
export default {
  data() {
    return {
      Cooperation: Cooperation,
      isComplete: true,
      isRelease: false,
      releaseData: null,
    };
  },
  mounted() {
    // 要素見えない可能性あるのでスクロール入れる
    const element = document.getElementById("js-scroll");
    element.scrollIntoView({ behavior: "smooth" });
  },
  props: {
    email: {
      type: String,
    },
    appauthid: {
      type: String,
    },
    lang: {
      type: String,
    },
    langPath: {
      type: String,
    },
    nassId: {
      type: String,
    },
    eventId: {
      type: String,
    },
    eventName: {
      type: String,
    },
    runnerName: {
      type: String,
    },
  },
  methods: {
    releaseEvent: async function () {
      if (confirm(Cooperation.unsync[this.lang])) {
        const data = {
          event_id: this.eventId,
          email: this.email,
          app_auth_code: this.appauthid,
          application: "runkeeper",
        };
        try {
          const OauthUserRepository = RepositoryFactory.get("oauth");
          const response = await OauthUserRepository.postRelease(data);
          this.releaseData = response.data;
        } catch (e) {
          return console.error(e);
        }
        if (this.releaseData.count) {
          this.isRelease = true;
          this.isComplete = false;
        }
      }
    },
  },
  computed: {
    eventLinkDescriptionText: function () {
      if (this.lang === "ja") {
        return `あなたは${this.eventName}のASICS Runkeeper™との連携が完了しています。アプリ連携を行なったアカウントでログインしているかご確認ください。`;
      }
      return `Your ASICS Runkeeper™ App account to the ${this.eventName} is successfully synced.`;
    },
    eventDetailText: function () {
      if (this.lang === "ja") {
        return `${this.eventName}${this.Cooperation.detail["ja"]}`;
      }
      return `${this.Cooperation.detail["en"]} ${this.eventName}`;
    },
  },
  components: {
    Release,
    PrimaryButton,
  },
  name: "Cooperation",
};
</script>

<style scoped>
.cooperation {
  .sub-title {
    font-size: 32px;
    text-align: center;
  }
  .oauth-description {
    margin: 45px 0 0 0;
  }
  .oauth-sentence {
    margin: 25px 0 0 0;
    display: flex;
    align-items: center;
  }
  .app-os {
    margin: 45px 0 0 0;
    font-size: 28px;
    text-align: center;
  }
  .app-image {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    &__p {
      margin: 26px 0 0 0;
    }
    .img {
      margin: 13px 0 0 0;
      box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.16);
    }
  }
  .app-name {
    font-size: 24px;
    font-weight: bold;
  }
  .event-detail {
    margin: 25px 0 0 0;
    display: flex;
    align-items: center;
  }
  .link {
    margin: 0 0 0 10px;
    color: var(--defaultBlackColor);
  }
  &__dl {
    margin: 45px 0 0 0;
    &--dt {
      font-size: 16px;
      font-weight: bold;
      color: var(--defaultBlackColor);
    }
    &--dd {
      margin: 10px 0 0 0;
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/oauth/Cooperation.vue